export default __webpack_public_path__ + "static/media/favicon.bc368d10.ico";